var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hasError)?_c('p',[_vm._v("Initializing...")]):_c('p',[_vm._v("Error occurs. Please try again.")])])}
var staticRenderFns = []

export { render, staticRenderFns }